export const forms = {
	'eventinfo': 'eventinfo',
	
}


// WEBPACK FOOTER //
// ./src/utils/constants/forms.js